var _excluded = ["attributes", "children", "nodeProps", "styles", "element", "classNames", "prefixClassNames"],
  _excluded2 = ["type"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { createStyles } from '@udecode/plate-styled-components';
import _styled from 'styled-components';
import React from 'react';
import { setNodes, getPreventDefaultHandler } from '@udecode/plate-common';
import { useEditorRef, useStoreEditorState, useEventEditorId } from '@udecode/plate-core';
import { useReadOnly, ReactEditor } from 'slate-react';
import { ELEMENT_UL, getListItemEntry, toggleList } from '@udecode/plate-list';
import { ToolbarElement } from '@udecode/plate-toolbar';
var getTodoListElementStyles = function getTodoListElementStyles(props) {
  return createStyles(_objectSpread({
    prefixClassNames: 'TodoListElement'
  }, props), _objectSpread(_objectSpread({
    root: {
      "display": "flex",
      "flexDirection": "row",
      "paddingTop": "0.25rem",
      "paddingBottom": "0.25rem"
    }
  }, props.checked && {
    rootChecked: {}
  }), {}, {
    checkboxWrapper: {
      "display": "flex",
      "alignItems": "center",
      "justifyContent": "center",
      "userSelect": "none",
      "marginRight": "0.375rem"
    },
    checkbox: {
      "width": "1rem",
      "height": "1rem",
      "margin": "0px"
    },
    text: [{
      "flex": "1 1 0%",
      ":focus": {
        "outline": "2px solid transparent",
        "outlineOffset": "2px"
      }
    }, props.checked && {
      "textDecoration": "line-through",
      "opacity": "0.666"
    }]
  }));
};
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function toVal(mix) {
  var k,
    y,
    str = '';
  if (typeof mix === 'string' || typeof mix === 'number') {
    str += mix;
  } else if (_typeof(mix) === 'object') {
    if (Array.isArray(mix)) {
      for (k = 0; k < mix.length; k++) {
        if (mix[k]) {
          if (y = toVal(mix[k])) {
            str && (str += ' ');
            str += y;
          }
        }
      }
    } else {
      for (k in mix) {
        if (mix[k]) {
          str && (str += ' ');
          str += k;
        }
      }
    }
  }
  return str;
}
function clsx() {
  var i = 0,
    tmp,
    x,
    str = '';
  while (i < arguments.length) {
    if (tmp = arguments[i++]) {
      if (x = toVal(tmp)) {
        str && (str += ' ');
        str += x;
      }
    }
  }
  return str;
}
var TodoListElement = function TodoListElement(props) {
  var _styles$rootChecked, _styles$checkboxWrapp, _styles$checkboxWrapp2, _styles$checkbox, _styles$checkbox2, _styles$text, _styles$text2;
  var attributes = props.attributes,
    children = props.children,
    nodeProps = props.nodeProps,
    _styles = props.styles,
    element = props.element,
    classNames = props.classNames,
    prefixClassNames = props.prefixClassNames,
    rootProps = _objectWithoutProperties(props, _excluded);
  var editor = useEditorRef();
  var readOnly = useReadOnly();
  var checked = element.checked;
  var styles = getTodoListElementStyles(_objectSpread(_objectSpread({}, props), {}, {
    checked: checked
  }));
  return /*#__PURE__*/React.createElement(_StyledDiv, _extends({}, attributes, rootProps, {
    className: clsx(styles.root.className, (_styles$rootChecked = styles.rootChecked) === null || _styles$rootChecked === void 0 ? void 0 : _styles$rootChecked.className, rootProps === null || rootProps === void 0 ? void 0 : rootProps.className),
    $_css: styles.root.css
  }), /*#__PURE__*/React.createElement(_StyledDiv2, {
    contentEditable: false,
    className: (_styles$checkboxWrapp = styles.checkboxWrapper) === null || _styles$checkboxWrapp === void 0 ? void 0 : _styles$checkboxWrapp.className,
    $_css2: (_styles$checkboxWrapp2 = styles.checkboxWrapper) === null || _styles$checkboxWrapp2 === void 0 ? void 0 : _styles$checkboxWrapp2.css
  }, /*#__PURE__*/React.createElement(_StyledInput, _extends({
    "data-testid": "TodoListElementCheckbox",
    className: (_styles$checkbox = styles.checkbox) === null || _styles$checkbox === void 0 ? void 0 : _styles$checkbox.className,
    type: "checkbox",
    checked: !!checked,
    onChange: function onChange(e) {
      var path = ReactEditor.findPath(editor, element);
      setNodes(editor, {
        checked: e.target.checked
      }, {
        at: path
      });
    }
  }, nodeProps, {
    $_css3: (_styles$checkbox2 = styles.checkbox) === null || _styles$checkbox2 === void 0 ? void 0 : _styles$checkbox2.css
  }))), /*#__PURE__*/React.createElement(_StyledSpan, {
    className: (_styles$text = styles.text) === null || _styles$text === void 0 ? void 0 : _styles$text.className,
    contentEditable: !readOnly,
    suppressContentEditableWarning: true,
    $_css4: (_styles$text2 = styles.text) === null || _styles$text2 === void 0 ? void 0 : _styles$text2.css
  }, children));
};
var _StyledDiv = _styled("div").withConfig({
  displayName: "TodoListElement___StyledDiv",
  componentId: "sc-1o2qsxo-0"
})(["", ""], function (p) {
  return p.$_css;
});
var _StyledDiv2 = _styled("div").withConfig({
  displayName: "TodoListElement___StyledDiv2",
  componentId: "sc-1o2qsxo-1"
})(["", ""], function (p) {
  return p.$_css2;
});
var _StyledInput = _styled("input").withConfig({
  displayName: "TodoListElement___StyledInput",
  componentId: "sc-1o2qsxo-2"
})(["", ""], function (p) {
  return p.$_css3;
});
var _StyledSpan = _styled("span").withConfig({
  displayName: "TodoListElement___StyledSpan",
  componentId: "sc-1o2qsxo-3"
})(["", ""], function (p) {
  return p.$_css4;
});
var ToolbarList = function ToolbarList(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? ELEMENT_UL : _ref$type,
    props = _objectWithoutProperties(_ref, _excluded2);
  var editor = useStoreEditorState(useEventEditorId('focus'));
  var res = !!(editor !== null && editor !== void 0 && editor.selection) && getListItemEntry(editor);
  return /*#__PURE__*/React.createElement(ToolbarElement, _extends({
    active: !!res && res.list[0].type === type,
    type: type,
    onMouseDown: editor && getPreventDefaultHandler(toggleList, editor, {
      type: type
    })
  }, props));
};
export { TodoListElement, ToolbarList, getTodoListElementStyles };